const route = {
  path: '/visual-data',
  name: '可视化数据',
  component: () => import('../views/visualization/visualizationData.vue'),
  children: []
}

export default route



// WEBPACK FOOTER //
// ./src/router/visualDataRouter.js